import React from "react";
import { useInvoice } from "../../../hooks/invoice/useInvoice";
import { ModalCharge } from "../../../shared/ModalCharge/ModalCharge";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { img } from "../../../../../../assets/img";
import classes from "../scss/ViewChargeAffirm.module.scss";
import ViewTipsModal from "../../ViewTipsModal/ViewTipsModal";
import { InputLabel } from "../../../../../../shared/InputLabel/InputLabel";
import { InputCurrency } from "../../../../../../shared/InputCurrency/InputCurrency";

const PaymentTipsModal = ({
  isTipsApplying,
  showTipsModal,
  form,
  isLoading,
  handlePayment,
}) => {
  const { invoice, amountToPay } = useInvoice();
  const { tSales } = useAppTranslation.Sales();
  const { tCommon } = useAppTranslation.Common();

  const { values, setFieldValue } = form;

  const onClose = () => {
    showTipsModal.update(false);
  };

  return (
    <ModalCharge
      isOpen
      onClose={onClose}
      title={tSales("checkoutInvoice.paymentOptions.affirm")}
      imageSrc={img.affirm}
      imageClassName={classes.titleIcon}
      onCharge={() =>
        handlePayment({
          amount: values.amount,
          email: values.email,
          phoneNumber: values.phoneNumber,
          country: values.country.value,
        })
      }
      isCharging={isLoading}
      isChargeDisabled={isTipsApplying}
      chargeLabel={tCommon("label.apply")}
    >
      <ViewTipsModal amountToPay={amountToPay} />
      <ModalCharge.InputWrap>
        <InputLabel>
          {tSales("checkoutInvoice.formInputLabel.amount")}
        </InputLabel>
        <InputCurrency
          size="medium"
          prefix={invoice?.currencySymbol}
          value={values.amount}
          placeholder={tSales("checkoutInvoice.formInputPlaceholder.amount")}
          onChange={(value) => setFieldValue("amount", value)}
        />
      </ModalCharge.InputWrap>
    </ModalCharge>
  );
};

export default PaymentTipsModal;
